import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
const LogOut = () => {
    let history = useHistory();
    const dispatch = useDispatch()  
        useEffect(() => { 
            localStorage.removeItem("token");
            localStorage.removeItem("serviceList");
            localStorage.clear();
            Swal.fire({
                text: 'You have Successfully Logged Out',
                icon: 'success',
                confirmButtonText: 'Ok',
                confirmButtonClass: "swal-button--confirm"
            }).then(
                function () {
                    history.push("/login")
                }
            );
    }, [])
    return (<>
    </>);
}
export default LogOut;